import React from 'react';
import { arrayOf, bool, func, object, oneOf, shape, string } from 'prop-types';

import ConfirmButton from '../../components/ConfirmButton';
import EsmsModal from '../../components/EsmsModal';

import { getErrorMessage, getErrors } from '../../helpers/errors';

import classes from './ProfileObjectModificationResultModal.module.css';

const ActionTitles = {
    create: 'Creation',
    delete: 'Deletion'
};
const ResultTitles = {
    create: 'created',
    delete: 'deleted'
};

const ProfileObjectModificationResultModal = ({
    errors,
    isCreate,
    modificationType,
    onClose,
    open
}) => (
    <EsmsModal
        open={open}
        onClose={onClose}
        title={`Profile ${ResultTitles[modificationType]} with errors`}
    >
        <p>
            Profile {ActionTitles[modificationType]} failed with the following errors:
        </p>
        {
            isCreate ?
                <ul className={classes.errors}>
                    {errors.map(({ item }, key) => (
                        <li key={key}>
                            {item.name}: {getErrors(item.messages)}
                        </li>
                    ))}
                </ul>
                :
                <ul className={classes.errors}>
                    {errors.map(({ item, error }, key) => (
                        <li key={key}>
                            {item.name}: {getErrorMessage(error)}
                        </li>
                    ))}
                </ul>
        }
        <footer className={classes.footer}>
            <ConfirmButton
                confirm={onClose}
                label="OK"
                type="button"
            />
        </footer>
    </EsmsModal>
);


ProfileObjectModificationResultModal.defaultProps = {
    errors:           [],
    onClose:          () => {},
    open:             false,
    modificationType: oneOf(Object.keys(ActionTitles))
};

ProfileObjectModificationResultModal.propTypes = {
    errors: arrayOf(shape({
        item: shape({
            name: string.isRequired
        }).isRequired,
        error: object.isRequired
    })),
    onClose: func,
    open:    bool
};

export default ProfileObjectModificationResultModal;
